export var EExtendedFieldTypes = /*#__PURE__*/function (EExtendedFieldTypes) {
  EExtendedFieldTypes["InputField"] = "inputField";
  EExtendedFieldTypes["MaskedInputField"] = "maskedInputField";
  EExtendedFieldTypes["PrivacyPolicyCheckbox"] = "privacyPolicyCheckbox";
  EExtendedFieldTypes["TextAreaField"] = "textAreaField";
  EExtendedFieldTypes["SelectField"] = "selectField";
  EExtendedFieldTypes["FileUploaderField"] = "fileUploaderField";
  EExtendedFieldTypes["RadioButtonGroupField"] = "radioButtonGroupField";
  EExtendedFieldTypes["HiddenField"] = "hiddenField";
  EExtendedFieldTypes["OwnerOfferLinkField"] = "ownerOfferLinkField";
  EExtendedFieldTypes["VillageSuggestField"] = "villageSuggestField";
  return EExtendedFieldTypes;
}({});